import script from "./PlanDetailsProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanDetailsProduct.vue?vue&type=script&setup=true&lang=js"

import "./PlanDetailsProduct.vue?vue&type=style&index=0&id=ae4ec210&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae4ec210"]])

export default __exports__